export default "/kiban/_next/static/images/emcShield-0131d1fe028ce0735b6972fcd9863e6a.png";